import ConnectShow from "../components/connect/Show";

export default [
  { name: 'Connect', path: '/connect', component: ConnectShow,  }
]
